<template>
  <!-- 存储位置 -->
    <div class="plateInStock">
      <div class="search">
        <div class="dataTime">
            <van-search
              v-model="searchValue"
              show-action
              placeholder="请输入查询的车牌号码"
              @search="onSearch"
              @input="onSearch"
              
            >
              <template #action>
                <div @click="onSearch(searchValue)">搜索</div>
              </template>
            </van-search>
            <span style="color: #fa8f04;font-weight: bold; font-size: 13px;float: right;margin-right: 5%;">{{ queryDataLength }}</span>
            <!-- <van-divider /> -->
          <van-divider style="margin: 0;" />
        </div>
      </div>
      <div class="searchContent">
        <van-list
          :finished="finished"
          finished-text="没有更多了"
        >
        <!-- <van-cell v-for="item in showList" :key="item.boxCode"  :title="'车牌号：'+item.plateNo ">
          <van-button  plain hairline type="info" @click="showDetail(item)">查看详情</van-button>
        </van-cell> -->
        <van-cell v-for="item in queryDataArray" :key="item.boxCode" >
          <van-row style="margin: 0 15px">
            <van-col :span="13">车牌号：{{item.plateNo}}</van-col>
            <van-col :span="11">料盒编号：{{item.boxCode}}</van-col>
          </van-row>
        </van-cell>
        </van-list>
      </div>
  
      <!-- 查看详情信息 -->
          <!-- <van-overlay :show="showDataDetail" @click="showDataDetail=false">
            <div class="wrapper" @click.stop>
              <div class="plateStateBlock">
                <div class="title">
                  <span>存储信息详情
                    <van-icon name="close" class="cancel" @click="cancelForm"/>
                  </span>
                </div>
                <van-cell title="车牌号码："  v-model="detailList.plateNo"/>
                <van-cell title="存放位置：" v-model="detailList.boxCode" />
                <div style="margin: 16px;">
                    <van-button round block type="info" @click="cancelForm">
                        确 定</van-button>
                </div>
              </div>
            </div>
          </van-overlay> -->
    </div>
  </template>
  
  <script>
  import {QueryBoxInfo} from '@/my_js//HttpRequest.js'
//   import {formatTime,getNowTime,formatDateTime} from '@/utils/date.js'
//   import { Notify } from 'vant'
  import PlateNumber from '../plateNo.vue'
import { Notify } from 'vant'
  export default {
    components:{
      PlateNumber
    },
    filters:{
    },
    mounted(){
      // this.onSearch()
      this.getInfo()
  },
    data(){
      return{
        // dataForm:{
        //   stayDays:null,//未领取天数
        // },
        searchValue:'',//搜索内容
        loading:false,
        finished:false,
        responseDataArray:[],//响应数据
        showDataDetail:false,//详情显示
        detailList:[],//详情信息列表
        // showList:[],//页面显示数据
        queryDataArray:[],//查询的数据
        queryDataLength:null,//查询到的数据量
        
      }
    },
    methods:{
      // 返回
      goBack(){
        console.log('返回管理员首页');
        this.$router.push('/manager')
      },
      // 搜索
      onSearch(val){
        this.loading = true
        console.log('搜索输入内容：',val);
        const data = {
            plateNo:val,
            // operateType:3
        }
      //  if(val == null || val == ''){
      //   this.responseDataArray = []
      //  }else{
      //   QueryBoxInfo(data).then(res => {
      //       console.log(res);
      //       this.responseDataArray = res.data
      //       console.log( 'this.responseDataArray',this.responseDataArray);
      //       this.showDataDetail = true
      //       // this.finished = true
      //       // this.loading=false
      //   })
      //  }

       if(val == null || val == ''){
        // this.detailList = []
        this.getInfo()
        console.log('11111111');
        
        // return Notify({message:'请输入要查询的车牌号',type:'warning'})
       }else{
        const upVal = this.trimmedStr(val).toUpperCase()
        console.log('upVal',upVal);
        
        // const boxInfo = this.responseDataArray.filter(item => item.plateNo == upVal)
       
        // 过滤之前确保 plateNo 不是 null 或 undefined
        const boxInfo = this.responseDataArray.filter(item => {
            const plateNo = item.plateNo ? item.plateNo.toUpperCase() : '';
            return plateNo.includes(upVal);
        });
        if(boxInfo.length != 0){
          // this.detailList = boxInfo[0]
          // console.log('detailList',this.detailList);
          // this.showDataDetail = true
          this.queryDataArray = boxInfo
          console.log('queryDataArray',this.queryDataArray);
          this.queryDataLength = this.queryDataArray.length
        }else{
          Notify({message:'该车牌号暂无存储信息，请稍后再查询',type:'warning'})
          this.queryDataArray = boxInfo
          this.queryDataLength = null
        }
        
       }
       
      },
      // 去除空格
      trimmedStr(str){
        return str.replace(/\s+/g,'')
      },
      // 获取全部料盒信息
      getInfo(){  
        QueryBoxInfo({plateNo:null}).then(res => {
            console.log(res);
            this.responseDataArray = res.data
            if(this.responseDataArray.length == 0){
              this.queryDataLength = null
            }else{
              this.queryDataArray = this.responseDataArray
              this.queryDataLength = this.responseDataArray.length
              console.log( 'this.responseDataArray',this.responseDataArray);
            }
            
            
            // this.showList = this.responseDataArray.filter(item => item.state == 2)
            // this.showList = this.responseDataArray
            // console.log('showList',this.showList);
            this.finished = true
        })
      },
      // 查看详情
      showDetail(val){
        console.log('val',val);
        this.showDataDetail = true
        // val.handleTime = formatTime(val.handleTime)
        this.detailList = val
      },
      // 关闭详情页面
      cancelForm(){
        this.searchValue = ''
        // this.onSearch()
        this.getInfo()
        this.showDataDetail = false
      },
  
    }
  
  }
  </script>
  
  <style lang="scss" >
  .plateInStock{
    .searchContent{
      .van-cell__title{
        line-height: 45px;
      }
    }
  
    .van-nav-bar__left{
      left: 0;
    }
    .van-nav-bar .van-icon{
      color: #0283ef;
    }
    .van-nav-bar__text{
      color: #0283ef;
    }
    .van-search__action{
      color: #0283ef;
      font-size: 18px;
    }
  
    .wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .title{
      margin-top: 3%;
      .cancel{
        float: right;
        margin-right: 3%;
        font-size: 28px;
      }
    }
    .plateStateBlock{
      width: 95%;
      // height: 35%;
      border-radius: 8px;
      background-color: #fff;
      .van-cell__value{
        text-align: left;
      }
      .van-field__control{
        width: 90%;
      }
    }
    }
   
  
  }
  
  </style>